import React, { useState } from "react";
import {
  List,
  ListItem,
  ListItemText,
  Checkbox,
  Card as MuiCard,
  Typography,
  Box,
  Divider,
  Button,
} from "@material-ui/core";
import logo from "../../../src/assets/logo.png";
import backIcon from "../../../src/assets/icons/backIcon.svg";
import { useStyles } from "./style";
import ClockIcon from "../Icons/ClockIcon";

interface LanguageScreenProps {
    handleLanguage: (setting: string) => void;
}

function LanguageSetting({ handleLanguage }: LanguageScreenProps) {
  const classes = useStyles();
  
  // State for selected languages
  const [selectedLanguages, setSelectedLanguages] = useState(["English (US)", "French"]);

  const recentlyUsedLanguages = ["English (US)", "French"];
  const allLanguages = ['Hindi', 'Arabic', 'Afrikaans', 'Mandarin'];

  const handleToggle = (language: string) => {
    setSelectedLanguages((prev) =>
      prev.includes(language)
        ? prev.filter((lang) => lang !== language)
        : [...prev, language]
    );
  };

  return (
    <div className={classes.container}>
      <MuiCard className={classes.card}>
        <Box style={{ display: "flex", justifyContent: "end", marginBottom: "40px" }}>
          <ClockIcon height={60} width={60} />
        </Box>
        <Box className={classes.header}>
          <img 
            src={backIcon} 
            alt="Back" 
            className={classes.backIcon} 
            onClick={() => handleLanguage("general")} 
          />
          <img src={logo} alt="Logo" className={classes.logo} />
        </Box>

        <Typography variant="h5" className={classes.communityHeading}>
          Settings and Preferences
        </Typography>

        <Typography variant="h6" style={{ marginTop: "20px", fontWeight: "bold" }}>
          Select Language
        </Typography>
        <Typography variant="body1" color="textSecondary" style={{ marginTop: "20px", fontWeight: "bold" }}>
          Recently Used
        </Typography>
        <List style={{ backgroundColor: "#F3F7FF", borderRadius: "10px", marginTop: "10px" }}>
          {recentlyUsedLanguages.map((language, index) => (
            <React.Fragment key={language}>
              <ListItem 
                button 
                onClick={() => handleToggle(language)}
                style={{ padding: "12px 16px" }}
              >
                <ListItemText primary={language} />
                <Checkbox
                  edge="end"
                  checked={selectedLanguages.includes(language)}
                  tabIndex={-1}
                  style={{ color: "#2158D0" }}
                />
              </ListItem>
              {index !== recentlyUsedLanguages.length - 1 && <Divider />}
            </React.Fragment>
          ))}
        </List>

        <Typography variant="body1" color="textSecondary" style={{ marginTop: "20px", fontWeight: "bold" }}>
          All Languages
        </Typography>
        <List style={{ backgroundColor: "#F3F7FF", borderRadius: "10px", marginTop: "10px" }}>
          {allLanguages.map((language, index) => (
            <React.Fragment key={language}>
              <ListItem 
                button 
                onClick={() => handleToggle(language)}
                style={{ padding: "12px 16px" }}
              >
                <ListItemText primary={language} />
                <Checkbox
                  edge="end"
                //   checked={selectedLanguages.includes(language)}
                  tabIndex={-1}
                  style={{ color: "#2158D0" }}
                />
              </ListItem>
              {index !== allLanguages.length - 1 && <Divider />}
            </React.Fragment>
          ))}
        </List>

        <Box className={classes.buttonContainer}>
               <Button variant="contained" className={classes.saveButton}>
                 Save Changes
               </Button>
            
             </Box>
      </MuiCard>
    </div>
  );
}

export default LanguageSetting;